<template>
  <v-container>
    <template v-if="['list'].includes(currentView)">
      <LonBroadcastList
        ref="broadcastList"
        :category-options="categoryOptions"
        @create-broadcast="handleChangeView('form')"
        @copy="handleCopyBroadcast"
        @delete="handleDeleteBroadcast"
        @edit="handleEdit"
        @select="handleSelect"
      />
    </template>
    <template v-if="['form'].includes(currentView)">
      <LonBroadcastManage
        ref="broadcastManage"
        @go-back="handleChangeView('list')"
        @submit="handleSubmitBroadcast"
      />
    </template>
    <template v-if="['view'].includes(currentView)">
      <LonBroadcastView ref="broadcastView" @go-back="handleChangeView('list')" />
    </template>
  </v-container>
</template>

<script>
import LonBroadcastList from './LonBroadcastList.vue'
import LonBroadcastManage from './LonBroadcastManage.vue'
import LonBroadcastView from './LonBroadcastView.vue'
import lineOfficialNotificationApi from '@/api/line-official-notification'
import lonCategoryApi from '@/api/lon-category'
import { mapGetters } from 'vuex'
import { PAGE_GROUP } from '@/constants/page'

export default {
  components: {
    LonBroadcastList,
    LonBroadcastManage,
    LonBroadcastView
  },
  data() {
    return {
      currentView: 'list',
      categoryOptions: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  created() {
    this.fetchCategories()
  },
  methods: {
    handleChangeView(type) {
      switch (type) {
        case 'list':
          this.currentView = 'list'
          break
        case 'view':
          this.currentView = 'view'
          break
        case 'form':
          this.currentView = 'form'
          break
        default:
          this.currentView = 'list'
          break
      }
    },
    async handleCopyBroadcast(broadcast) {
      const payload = {
        page_id: broadcast.page_id,
        messages: broadcast.messages,
        phone_number_list: broadcast.phone_number_list,
        delivery_tag: `${broadcast.delivery_tag} copy`,
        status: 'draft',
        schedule_timestamp: broadcast.schedule_timestamp
      }
      const response = await this.$swal.fire({
        title: this.$t('Do you want to copy {name}?', {
          name: payload.delivery_tag
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (response.value) {
        this.handleSubmitBroadcast(payload)
      }
    },
    async handleSubmitBroadcast(broadcast) {
      try {
        this.$store.dispatch('loading')
        const response =
          +broadcast.id > 0
            ? await lineOfficialNotificationApi.editLineOfficialNotificationBroadcast({
                data: broadcast
              })
            : await lineOfficialNotificationApi.createLineOfficialNotificationBroadcast({
                data: broadcast
              })
        const { status } = response
        if ([204].includes(status)) {
          this.$swal.fire({
            title: ['draft'].includes(broadcast.status)
              ? this.$t('Success! Broadcast {name} save', {
                  name: broadcast.delivery_tag
                })
              : this.$t('Broadcast {sent_name} sent', {
                  sent_name: broadcast.delivery_tag
                }),
            type: 'success',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })

          this.handleChangeView('list')
          if (this.$refs.broadcastList) this.$refs.broadcastList.handleReFetch()
        }
      } catch (error) {
        this.$swal.fire({
          title: this.$t('Error'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        console.error(error)
      } finally {
        this.$store.dispatch('clear_loading')
      }
    },
    async handleDeleteBroadcast(broadcast) {
      try {
        const response = await this.$swal.fire({
          title: this.$t('Do you want to delete {name}?', {
            name: broadcast.delivery_tag
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (response.value) {
          this.$store.dispatch('loading')
          const response =
            await lineOfficialNotificationApi.deleteLineOfficialNotificationBroadcast({
              data: {
                id: broadcast.id,
                page_id: broadcast.page_id
              }
            })
          const { status } = response
          if ([204].includes(status)) {
            this.$swal.fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm'),
              cancelButtonText: this.$t('cancel'),
              reverseButtons: true
            })
          }
        }
      } catch (error) {
        this.$swal.fire({
          title: this.$t('Error'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        console.error(error)
      } finally {
        if (this.$refs.broadcastList) this.$refs.broadcastList.handleReFetch()
        this.$store.dispatch('clear_loading')
      }
    },
    handleEdit(broadcast) {
      this.handleChangeView('form')
      setTimeout(() => {
        if (this.$refs.broadcastManage && Object.keys(broadcast).length > 0) {
          this.$refs.broadcastManage.handleFillForm(broadcast)
        }
      }, 0)
    },
    handleSelect(broadcast) {
      this.handleChangeView('view')
      setTimeout(() => {
        if (this.$refs.broadcastView && Object.keys(broadcast).length > 0) {
          this.$refs.broadcastView.handleFillForm(broadcast)
        }
      }, 0)
    },
    async fetchCategories() {
      try {
        const response = await lonCategoryApi.getCategories({
          page_id: this.selectedBot.pageid,
          limit: 1000,
          offset: 0
        })
        const { data } = response.data
        this.categoryOptions = data.map((item) => ({
          value: item.id,
          text: item.lon_category_name
        }))
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcast.vue